import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'mrsoftapps-epims-reference-spinner',
	templateUrl: './epims-reference-spinner.component.html',
	styleUrls: [ './epims-reference-spinner.component.scss' ]
})
export class EpimsReferenceSpinnerComponent implements OnInit {
	constructor() {}

	ngOnInit() {}
}
